/**
 * @generated SignedSource<<53217016bae42f3c22c0ff9200d73ae7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleLineTextField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly name: string;
  readonly text: string | null;
  readonly " $fragmentType": "JiraSingleLineTextField_Platform";
};
export type JiraSingleLineTextField_Platform$key = {
  readonly " $data"?: JiraSingleLineTextField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraSingleLineTextField_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraSingleLineTextField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "6cf15d61982b829c6f1f9f478b7976c8";

export default node;
